import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import api from "./services/api";
import i18n from "./services/i18n";
import store from "./store/store";
import { Provider } from "react-redux";
import { Navigate } from "react-router-dom";
import { I18nextProvider } from "react-i18next";

const addLocaleMessages = (locale, messages) => {
  const groupedMessages = messages.reduce((acc, { type, code, codeDesc }) => {
    if (!acc[type]) {
      acc[type] = {};
    }
    acc[type][code] = codeDesc;
    return acc;
  }, {});

  Object.keys(groupedMessages).forEach((type) => {
    i18n.addResourceBundle(locale, type, groupedMessages[type], true, true);
  });
};

const loadLocaleMessages = async () => {
  try {
    const response = await api.post("/common/i18n", {});
    const data = response.data;

    if (data.kor) {
      addLocaleMessages("kor", data.kor);
    }

    if (data.eng) {
      addLocaleMessages("eng", data.eng);
    }
  } catch (err) {
    return <Navigate to="/error" replace={true} />;
  }
};

const initApp = async () => {
  await loadLocaleMessages();
  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <App />
        </Provider>
      </I18nextProvider>
    </React.StrictMode>
  );
};

initApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
